export default __webpack_public_path__ + "static/media/carlosvalenciaAbout.ffdf432e.jpg";